import React, { Component } from 'react';
import { ReferenceField } from 'app-types';
import styles from './ReferenceFields.module.scss';

interface Props {
	referenceFields: ReferenceField[];
}

export default class ReferenceFieldsDisplayList extends Component<Props> {
	render() {
		const { referenceFields } = this.props;

		return (
			<ul>
				{referenceFields.map(field => (
					<li key={field.customerReferenceFieldId}>
						<span className={styles.referenceLabel}>{field.referenceFieldName}:</span>{' '}
						{field.value}
					</li>
				))}
			</ul>
		);
	}
}
